import { Title, Text, Group, Button } from "@mantine/core"
import { IconDeviceFloppy } from "@tabler/icons-react"

import { ICON_SIZE } from "@costory/shared/const"

interface TransformationHeaderProps {
  transformationsCount: number
  hasUnsavedChanges: boolean
  hasWorkInProgress: boolean
  onSave: () => void
  onDiscard: () => void
  isSaving: boolean
  isDeletingAll: boolean
}

export function TransformationHeader({
  transformationsCount,
  hasUnsavedChanges,
  hasWorkInProgress,
  onSave,
  onDiscard,
  isSaving,
  isDeletingAll,
}: TransformationHeaderProps) {
  return (
    <Group justify="space-between" align="center">
      <div>
        <Title order={2}>Edit Ingested Labels</Title>
        <Text size="sm" c="dimmed">
          {transformationsCount} transformations configured
          {hasUnsavedChanges && " • Unsaved changes"}
        </Text>
      </div>
      <Group gap="sm">
        {!hasWorkInProgress ? (
          <Button
            variant="light"
            onClick={onDiscard}
            disabled={isSaving || isDeletingAll}
          >
            Go Back
          </Button>
        ) : (
          <Button
            variant="light"
            disabled={isSaving || isDeletingAll}
            onClick={onDiscard}
          >
            Discard
          </Button>
        )}
        <Button
          leftSection={<IconDeviceFloppy size={ICON_SIZE} />}
          disabled={
            transformationsCount === 0 ||
            isSaving ||
            isDeletingAll ||
            !hasUnsavedChanges
          }
          loading={isSaving || isDeletingAll}
          onClick={onSave}
          color={hasUnsavedChanges ? "primary" : "gray"}
        >
          {isSaving
            ? "Saving..."
            : isDeletingAll
              ? "Deleting..."
              : hasUnsavedChanges
                ? "Save All Transformations"
                : "All Changes Saved"}
        </Button>
      </Group>
    </Group>
  )
}
